'use strict';

const angular = require('angular');

module.exports = angular
  .module('spinnaker.core.region.regionSelectField.directive', [
  ])
  .directive('regionSelectField', function () {
    return {
      restrict: 'E',
      templateUrl: require('./regionSelectField.directive.html'),
      scope: {
        regions: '=',
        component: '=',
        field: '@',
        account: '=',
        provider: '=',
        onChange: '&',
        labelColumns: '@',
        fieldColumns: '@',
        readOnly: '=',
      },
    };
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/region/regionSelectField.directive.js